import { yupResolver } from "@hookform/resolvers/yup";
import {
  toastrErrorAlert,
  toastrSuccessAlert,
} from "components/Common/AlertToastr";
import { CommonButton } from "components/Common/ButtonCommon";
import HeaderCreateItem from "components/Common/HeaderCreateItem";
import useGetFormSchema from "custom-hook/useGetFormSchema";
import { formatNumber } from "helpers/erp_helper";
import { GET_REFFERAL_BONUS_POLICY } from "helpers/url_helper";
import moment from "moment";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import httpService from "services/httpService";
import * as yup from "yup";

export default function NewReferralBonusPolicy() {
  const { id } = useParams();
  const history = useHistory();

  const schema = yup
    .object({
      bonusAmount: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
          : yup
              .number()
              .typeError(`Tiền thưởng phải là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
      ),
      valueFrom: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
              .required("Vui lòng nhập giá trị từ")
          : yup
              .number()
              .typeError(`Giá trị từ phải là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
              .required("Vui lòng nhập giá trị từ")
      ),
      valueTo: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
              .required("Vui lòng nhập giá trị đến")
          : yup
              .number()
              .typeError(`Số lượng phải là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
              .required("Vui lòng nhập giá trị đến")
      ),
      bonusPercentage: yup.lazy(value =>
        typeof value === "string"
          ? yup
              .string()
              .transform((_, val) => val && Number(val.replaceAll(".", "")))
          : yup
              .number()
              .typeError(`Số lượng phải là số!`)
              .nullable()
              .moreThan(0, "Floor area cannot be negative")
      ),
      applyFor: yup.string().required("Vui lòng chọn áp dụng cho"),
      criteria: yup.string().required("Vui lòng chọn tiêu chí"),
    })
    .required();

  useEffect(() => {
    getRefferalBonusPolicyDetail();
  }, [id]);

  const {
    handleSubmit,
    formState: { errors },
    ...rest
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { renderForm } = useGetFormSchema(
    "ReferralBonusPolicy",
    yup,
    rest,
    errors
  );

  const getRefferalBonusPolicyDetail = async () => {
    if (!id) return;

    const res = await httpService.get(
      `${GET_REFFERAL_BONUS_POLICY}/${id}?include=["department"]`
    );

    if (!res) {
      history.replace("/referral-bonus-policy");
      toastrErrorAlert("Refferal Bonus Policy not found!");
      return;
    }
    const { reset } = rest;
    reset({
      ...res,
      bonusAmount: formatNumber(res?.bonusAmount),
      valueFrom: formatNumber(res?.valueFrom),
      valueTo: formatNumber(res?.valueTo),
      department: res?.department
        ? {
            text: res.department?.name,
            objectId: res.department.objectId,
            className: "Department",
            __type: "Pointer",
          }
        : { text: "" },
      createdAt: moment(res?.createdAt).format("YYYY-MM-DD"),
      updatedAt: moment(res?.updatedAt).format("YYYY-MM-DD"),
    });
  };

  const onSubmit = async values => {
    const {
      objectId,
      createdAt,
      updatedAt,
      bonusPercentage,
      bonusAmount,
      department,
      valueFrom,
      valueTo,
      ...remaining
    } = values;

    const newReferralBonusPolicy = {
      ...remaining,
      ...(values.bonusPercentage !== "" && {
        bonusPercentage: values.bonusPercentage,
      }),
      ...(values.bonusAmount !== "" && {
        bonusAmount: values.bonusAmount,
      }),
      ...(values.valueFrom !== "" && {
        valueFrom: values.valueFrom,
      }),

      ...(values.valueTo !== "" && {
        valueTo: values.valueTo,
      }),

      ...(values.department.text !== "" && {
        department: {
          objectId: values.department.objectId,
          className: "Department",
          __type: "Pointer",
        },
      }),
    };

    if (id) {
      try {
        const res = await httpService.put(
          `${GET_REFFERAL_BONUS_POLICY}/${id}`,
          newReferralBonusPolicy
        );
        if (res.updatedAt) {
          toastrSuccessAlert("Cập nhật chính sách hoa hồng thành công!!");
          return;
        }
        toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
      } catch (error) {
        toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
      }
      return;
    }
    try {
      const res = await httpService.post(
        `${GET_REFFERAL_BONUS_POLICY}`,
        newReferralBonusPolicy
      );
      if (res.createdAt) {
        toastrSuccessAlert("Tạo chính sách hoa hồng thành công!!");
        history.replace(`/referral-bonus-policy/${res.objectId}`);
        return;
      }
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
    } catch (error) {
      toastrErrorAlert("Đã xảy ra lỗi, vui lòng thử lại sau!!");
    }
  };
  return (
    <div className="page-content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <HeaderCreateItem title={"Chi tiết chính sách hoa hồng / thưởng"}>
          <CommonButton level={0} type="submit">
            Save
          </CommonButton>
        </HeaderCreateItem>
        <Container fluid>{renderForm([])}</Container>
      </form>
    </div>
  );
}
